<template>
    <div
        class="accordion accordion-flush shadow-sm"
        :id="'accordionFlush-' + id"
    >
        <div class="accordion-item">
            <div class="accordion-header" :id="'flush-headingOne-' + id">
                <div
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#flush-collapseOne-' + id"
                    aria-expanded="false"
                    :aria-controls="'flush-collapseOne-' + id"
                >
                    <div class="col-2 text-center">
                        <img
                            v-if="photo"
                            :src="photo"
                            :alt="name"
                            class="rounded-circle img-fluid"
                            width="50"
                            height="50"
                        />
                    </div>
                    <div class="col-9 ps-3">
                        <h2 v-if="name" class="h6 mb-0">
                            <strong>{{ name }}</strong>
                        </h2>
                        <p v-if="position" class="lh-1 mb-0">
                            <small>{{ position }}</small>
                        </p>
                    </div>
                </div>
            </div>
            <div
                :id="'flush-collapseOne-' + id"
                class="accordion-collapse collapse"
                :aria-labelledby="'flush-headingOne-' + id"
                :data-bs-parent="'#accordionFlush-' + id"
            >
                <div class="accordion-body d-flex flex-column pt-0 pb-3">
                    <a
                        v-if="email"
                        class="text-decoration-none text-black"
                        :href="'mailto:' + email"
                    >
                        <i class="fa fa-envelope me-2"></i>{{ email }}
                    </a>
                    <a
                        v-if="phone"
                        class="text-decoration-none text-black"
                        :href="'tel:' + phone"
                    >
                        <i class="fa fa-phone me-2"></i>{{ phone }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: String,
        name: String,
        position: String,
        phone: String,
        email: String,
        photo: String,
    },
};
</script>

<style scoped>
.accordion-button:not(.collapsed) {
    color: #000;
    background-color: #fff;
    box-shadow: none;
}
.accordion-button:not(.collapsed)::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}
</style>
